import { render, staticRenderFns } from "./DataRecordsFilters.vue?vue&type=template&id=5f158a49&scoped=true&"
import script from "./DataRecordsFilters.vue?vue&type=script&lang=js&"
export * from "./DataRecordsFilters.vue?vue&type=script&lang=js&"
import style0 from "./DataRecordsFilters.vue?vue&type=style&index=0&id=5f158a49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f158a49",
  null
  
)

export default component.exports